<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          EMISSÃO DE FATURA DE ROYALTIES INDIVIDUAL
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        class="compact-form"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="5" lg="3" class="py-1">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2" class="py-1">
              <v-select
                :items="billing_types"
                v-model="billing_type"
                label="Tipos de Faturamento"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              md="2"
              class="py-1"
              v-if="billing_type === 2"
            >
              <v-select
                :items="months"
                v-model="month_billing"
                label="Mês Retificação"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              md="2"
              class="py-1"
              v-if="billing_type === 2"
            >
              <v-select
                :items="years"
                v-model="year_retification"
                label="Ano Retificação"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2" class="py-1">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="loadInvoices"
              >
                <v-icon> mdi-plus </v-icon>
                Carregar Notas Fiscais
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="
              invoices.length > 0 ||
              (invoices.length == 0 && invoices_restitution.length == 0)
            "
          >
            <v-col class="py-1">
              <v-card outlined rounded>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold subtitle-2"
                  height="28"
                  dense
                  outlined
                  flat
                  dark
                  >NOTAS FISCAIS PARA FATURAMENTO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col class="py-1">
                      <v-simple-table dense fixed-header height="150">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap" width="25%">
                                Fornecedor
                              </th>
                              <th class="text-left text-no-wrap">Emissão</th>
                              <th class="text-right text-no-wrap">
                                Nota Fiscal
                              </th>
                              <th class="text-left text-no-wrap">Lançamento</th>
                              <th class="text-right text-no-wrap">
                                Vr. Nota Fiscal
                              </th>
                              <th class="text-right text-no-wrap">Qt. Total</th>
                              <!-- <th class="text-left text-no-wrap">
                                Vr. Descontos
                              </th>
                              <th class="text-left text-no-wrap">
                                Vr. Acréscimos
                              </th> -->
                              <th class="text-left text-no-wrap">Nº Pedidos</th>
                              <th class="text-left text-no-wrap" width="70px">
                                (%)Royalties
                              </th>
                              <th class="text-left text-no-wrap" width="60px">
                                Ação
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="invoice in invoices" :key="invoice.id">
                              <td>
                                {{ invoice.provider.code }} -
                                {{ invoice.provider.name }}
                              </td>
                              <td>{{ invoice.issue_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ invoice.number }}-{{ invoice.serie }}
                              </td>
                              <td>{{ invoice.invoice_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ invoice.value | currencyEuaToBr }}
                              </td>
                              <td class="text-right">{{ invoice.quantity }}</td>
                              <!-- <td class="text-right">0,00</td> -->
                              <!-- <td class="text-right">0,00</td> -->
                              <td>{{ invoice.orders.length }}</td>
                              <td>
                                <v-text-field
                                  label=""
                                  outlined
                                  hide-details
                                  disabled
                                  dense
                                  v-model="invoice.royalties"
                                  class="fs-12"
                                ></v-text-field>
                              </td>
                              <td>
                                <v-tooltip top color="error">
                                  <!-- eslint-disable-next-line -->
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="red darken-1"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="deleteInvoice(invoice)"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>Deletar</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="invoices_restitution.length > 0">
            <v-col class="py-1">
              <v-card outlined rounded>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold subtitle-2"
                  height="28"
                  dense
                  outlined
                  flat
                  dark
                  >NOTAS FISCAIS INDENIZAÇÃO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col class="py-1">
                      <v-simple-table dense fixed-header height="120">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap" width="25%">
                                Fornecedor
                              </th>
                              <th class="text-left text-no-wrap">Emissão</th>
                              <th class="text-left text-no-wrap">
                                Nota Fiscal
                              </th>
                              <th class="text-left text-no-wrap">Lançamento</th>
                              <th class="text-left text-no-wrap">
                                Vr. Nota Fiscal
                              </th>
                              <th class="text-left text-no-wrap">Qt. Total</th>
                              <!-- <th class="text-left text-no-wrap">
                                Vr. Descontos
                              </th>
                              <th class="text-left text-no-wrap">
                                Vr. Acréscimos
                              </th> -->
                              <th class="text-left text-no-wrap">Nº Pedidos</th>
                              <th class="text-left text-no-wrap" width="70px">
                                (%)Royalties
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="invoice in invoices_restitution"
                              :key="invoice.id"
                            >
                              <td>
                                {{ invoice.provider.code }} -
                                {{ invoice.provider.name }}
                              </td>
                              <td>{{ invoice.issue_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ invoice.number }}-{{ invoice.serie }}
                              </td>
                              <td>{{ invoice.invoice_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ invoice.value | currencyEuaToBr }}
                              </td>
                              <td class="text-right">{{ invoice.quantity }}</td>
                              <!-- <td class="text-right">0,00</td> -->
                              <!-- <td class="text-right">0,00</td> -->
                              <td>{{ invoice.orders.length }}</td>
                              <td>
                                <v-text-field
                                  label=""
                                  outlined
                                  hide-details
                                  disabled
                                  dense
                                  value="0,00"
                                  class="fs-12"
                                ></v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="8" class="py-1">
              <v-card outlined>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold subtitle-2"
                  height="28"
                  dense
                  outlined
                  flat
                  dark
                  >FINANCEIRO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col class="pt-1 pb-1">
                      <v-simple-table dense fixed-header height="200">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th>Tipo de Lançamento</th>
                              <th>Descrição</th>
                              <th class="text-right">Valor</th>
                              <th class="text-right">Ação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="release in releases" :key="release.id">
                              <td>
                                (
                                {{
                                  release.operation == "desconto" ? "-" : "+"
                                }}
                                ) {{ release.description }}
                              </td>
                              <td>{{ release.history }}</td>
                              <td class="text-right">
                                {{ release.value | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                <v-tooltip top color="error">
                                  <!-- eslint-disable-next-line -->
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="red darken-1"
                                      @click="deleteRelease(release)"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>Deletar Lançamento</span>
                                </v-tooltip>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4">
                                <v-btn
                                  color="blue darken-3 white--text"
                                  @click="handleAddFinancial()"
                                  small
                                >
                                  <v-icon> mdi-check </v-icon>
                                  Adicionar Lançamento
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col class="pt-0 pb-1">
                      
                    </v-col>
                  </v-row> -->
                  <!-- <v-row>
                    <v-col cols="12" class="py-2">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="5" class="py-1">
                      <v-row>
                        <v-col class="py-1">
                          <v-select
                            :items="types_installment"
                            v-model="installment"
                            label="Tipo de Parcelamento"
                            @change="changeInstallment()"
                            hide-details
                            dense
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-card outlined height="240">
                            <v-card-title
                              class="
                                font-weight-bold
                                black--text
                                subtitle-2
                                py-1
                              "
                            >
                              Dados para Geração
                            </v-card-title>
                            <v-card-text>
                              <v-form
                                ref="form"
                                lazy-validation
                                class="compact-form"
                              >
                                <v-text-field
                                  v-if="installment == 1"
                                  v-model="parcels_config.number"
                                  label="Número de Parcelas"
                                  outlined
                                  dense
                                  hide-details
                                  class="mb-4"
                                  required
                                ></v-text-field>
                                <v-text-field-money
                                  v-if="installment == 2"
                                  v-model="parcels_config.value"
                                  label="Valor das Parcelas"
                                  class="mb-4"
                                  v-bind:properties="{
                                    prefix: '',
                                    readonly: false,
                                    dense: true,
                                    hideDetails: true,
                                    outlined: true,
                                    clearable: false,
                                    placeholder: ' ',
                                  }"
                                  v-bind:options="{
                                    locale: 'pt-BR',
                                    length: 11,
                                    precision: 2,
                                    empty: null,
                                  }"
                                />
                                <v-text-field
                                  v-model="parcels_config.date_first_parcel"
                                  v-mask="dateMask"
                                  label="Data Primeira Parcela"
                                  outlined
                                  dense
                                  hide-details
                                  class="mb-4"
                                  required
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="handleClickCalendar()"
                                ></v-text-field>
                                <v-text-field
                                  v-model="parcels_config.interval"
                                  label="Intervalo Dias Entre Datas"
                                  outlined
                                  dense
                                  hide-details
                                  class="mb-4"
                                  required
                                ></v-text-field>
                                <v-row>
                                  <v-col class="py-1">
                                    <v-btn
                                      color="blue darken-3 white--text"
                                      class="mt-2"
                                      small
                                      :disabled="validDisabledParcels()"
                                      @click="generateParcels()"
                                    >
                                      <v-icon> mdi-check </v-icon>
                                      Gerar Duplicatas
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-form>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="7" class="py-1">
                      <v-simple-table dense fixed-header height="240">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th>Parcela</th>
                              <th>Emissão</th>
                              <th>Vencimento</th>
                              <th class="text-right">Vr. Documento</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="parcel in parcels" :key="parcel.parcel">
                              <td>{{ parcel.parcel }}</td>
                              <td>{{ parcel.issuance_date | dateToBr }}</td>
                              <td>{{ parcel.due_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ parcel.value | currencyEuaToBr }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="parcels.length > 1">
                            <tr>
                              <th colspan="4">{{ parcels.length }} Parcelas</th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" md="4" class="py-1">
              <v-row style="margin-right: 0px">
                <v-card outlined class="mt-3">
                  <v-toolbar
                    color="blue darken-4"
                    class="font-weight-bold subtitle-2"
                    height="28"
                    dense
                    outlined
                    flat
                    dark
                    >RESUMO DA OPERÇÃO</v-toolbar
                  >
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >TOTAL NOTAS FISCAIS:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >{{ getTotalSum("value") | currencyEuaToBr }}</v-col
                      >
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >TOTAL DE INDENIZAÇÃO:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >{{
                          getTotalSumRestitution("value") | currencyEuaToBr
                        }}</v-col
                      >
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >QUANTIDADE TOTAL:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >{{ getTotalSum("quantity") }}</v-col
                      >
                      <!-- <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >VALOR TOTAL DOS PRODUTOS:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >0,00</v-col
                      > -->
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          red--text
                        "
                        >(-) TOTAL DOS ABATIMENTOS:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          red--text
                        "
                        >{{
                          getTotalReleases("desconto") | currencyEuaToBr
                        }}</v-col
                      >
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          green--text
                        "
                        >(+) TOTAL DOS ACRÉSCIMOS:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          green--text
                        "
                        >{{
                          getTotalReleases("acrescimo") | currencyEuaToBr
                        }}</v-col
                      >
                      <v-col cols="12" class="py-1">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >BASE DE CALCULO DOS ROYALTIES:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >{{ getTotalSum("value") | currencyEuaToBr }}</v-col
                      >
                      <v-col cols="12" class="py-1">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          blue--text
                        "
                        >TOTAL DE ROYALTIES A PAGAR:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          blue--text
                        "
                        >{{ getValueRoyalties() | currencyEuaToBr }}</v-col
                      >
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >TOTAL DOS LANÇAMENTOS:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >{{ getTotalReleases() | currencyEuaToBr }}</v-col
                      >
                      <v-col cols="12" class="py-1">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="8"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >TOTAL DO FATURAMENTO:</v-col
                      >
                      <v-col
                        cols="4"
                        class="
                          py-0
                          caption
                          text-right
                          font-weight-black
                          black--text
                        "
                        >{{ getValueTotal() | currencyEuaToBr }}</v-col
                      >
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    dark
                    color="green darken-3"
                    class="float-right"
                    small
                    @click="validate"
                  >
                    <v-icon> mdi-check </v-icon>
                    Gerar Documento do Faturamento
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
    <v-dialog ref="dialog" v-model="modalAddRelease" width="500px">
      <v-card>
        <v-toolbar color="blue darken-1" dark class="text-h5"
          >Lançamento</v-toolbar
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  :items="types_release"
                  item-text="description_full"
                  item-value="id"
                  v-model="form_release.id"
                  label="Tipo de Lançamento"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  name="input-7-1"
                  label="Descrição"
                  class="text-field-uppercase"
                  auto-grow
                  dense
                  outlined
                  :value="form_release.history"
                  @input="(value) => (form_release.history = value)"
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-text-field-money
                  v-model="form_release.value"
                  label="Valor"
                  v-bind:properties="{
                    prefix: '',
                    readonly: false,
                    dense: true,
                    hideDetails: true,
                    outlined: true,
                    clearable: false,
                    placeholder: ' ',
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 11,
                    precision: 2,
                    empty: null,
                  }"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeAddRelease()"
            >Fechar</v-btn
          >
          <v-btn color="blue darken-1" dark @click="confirmAddRelease()">
            <v-icon dark>mdi-check</v-icon>
            Confirmar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";
import AwesomeMask from "awesome-mask";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    companies: [],
    billing_types: [
      { value: 1, text: "Normal" },
      { value: 2, text: "Retificação" },
    ],
    billing_type: 1,
    types_installment: [
      { value: 1, text: "Nº de Parcelas" },
      { value: 2, text: "Valor das Parcelas" },
    ],
    installment: 1,
    company: "",
    loading: false,
    showAlert: false,
    messageAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
    invoices: [],
    invoices_restitution: [],
    parcels_config: {
      value: "0.00",
      number: 1,
      interval: 1,
      date_first_parcel: "",
    },
    parcels: [],
    releases: [],
    dateDialog: "",
    modalDate: false,
    modalAddRelease: false,
    types_release: [],
    form_release: {
      id: "",
      name: "",
      history: "",
      value: "",
    },
    month_billing: "",
    years: [],
    year_retification: "",
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
  }),
  computed: {},
  created() {
    this.initialize();
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateToBr: function (date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
  },
  methods: {
    async initialize() {
      let dateNow = new Date();
      this.month_billing = dateNow.getMonth() + 1;
      this.year_retification = dateNow.getFullYear();
      let yearNow = dateNow.getFullYear();

      // COLOCA 10 ANOS PARA TRAS
      for (let i = 10; i >= 0; i--) {
        this.years.push(yearNow - i);
      }
      this.years = this.years.reverse();
      this.getCompanies();
      this.getFinancialReleaseType();
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getFinancialReleaseType() {
      this.types_release = [];
      try {
        let response = await fetch(`${URL}financial-release-type`);
        let res = await response.json();
        console.log(res);
        this.types_release = res.map((item) => ({
          ...item,
          description_full: `( ${
            item.operation == "desconto" ? "-" : "+"
          } ) ${item.operation.toUpperCase()} - ${item.description}`,
        }));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    validate() {
      let value = this.getValueTotal();
      if (
        this.invoices.length === 0 &&
        this.invoices_restitution.length === 0
      ) {
        this.messageAlert = "É necessário ter notas fiscais para faturamento";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }
      if (this.parcels.length === 0 && this.invoices.length > 0 && value > 0) {
        this.messageAlert = "É necessário gerar Duplicatas para continuar";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }
      const data = {};
      data.royalty = {
        company_id: this.company,
        type: this.billing_type,
        value: this.getValueTotal(),
      };
      data.invoices = this.invoices;
      data.invoices_restitution = this.invoices_restitution;
      data.parcels = this.parcels;
      data.releases = this.releases;
      data.month_billing = this.month_billing;
      data.year_billing = this.year_billing;
      this.post(data);
    },
    async loadInvoices() {
      this.loading = true;
      this.showAlert = false;
      try {
        let res = await fetch(`${URL}invoice?franchise=${this.company}`);
        if (!res.ok) {
          throw new Error(res.message);
        }
        let data = await res.json();
        if (data.length === 0) {
          this.typeAlert = "warning";
          this.messageAlert = "Não existem notas para faturar";
          this.showAlert = true;
          this.$vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
        }
        this.invoices = this.filterByRestitution(data, 0);
        this.invoices_restitution = this.filterByRestitution(data, 1).map(
          (item) => ({ ...item, royalties: 0 })
        );
      } catch (error) {
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao carregar as notas, tente novamente mais tarde";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    filterByRestitution(data, restitution) {
      return data
        .map((item) => ({
          ...item,
          orders: item.orders.filter((ord) => ord.restitution == restitution),
        }))
        .filter((item) => item.orders.length > 0)
        .map((item) => ({
          ...item,
          quantity: item.quantity,
          value: item.value,
        }));
    },
    deleteInvoice(invoice) {
      let copyInvoices = [
        ...this.invoices.filter((item) => item.id !== invoice.id),
      ];
      this.invoices = [...copyInvoices];
    },
    getTotalSum(field) {
      let total = this.invoices.reduce(
        (prev, curr) =>
          prev +
          (!isNaN(parseFloat(curr[field])) ? parseFloat(curr[field]) : 0),
        0
      );

      let decimal_fields = ["value"];

      return !decimal_fields.includes(field)
        ? parseInt(total)
        : total.toFixed(2);
    },
    getTotalSumRestitution(field) {
      let total_restitution = this.invoices_restitution.reduce(
        (prev, curr) =>
          prev +
          (!isNaN(parseFloat(curr[field])) ? parseFloat(curr[field]) : 0),
        0
      );

      let decimal_fields = ["value"];

      return !decimal_fields.includes(field)
        ? parseInt(total_restitution)
        : total_restitution.toFixed(2);
    },
    getValueRoyalties() {
      return this.invoices
        .map(
          (item) => parseFloat(item.value) * (parseFloat(item.royalties) / 100)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    getValueTotal() {
      return (
        parseFloat(this.getValueRoyalties()) +
        parseFloat(this.getTotalReleases())
      );
    },
    async post(data) {
      this.loading = true;
      this.showAlert = false;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}royalty`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.messageAlert = response.message;
        this.typeAlert = "success";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        this.clear();
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao fazer emissão da fatura de roylaties, tente novamente mais tarde";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    clear() {
      this.invoices = [];
      this.invoices_restitution = [];
      this.parcels = [];
      this.releases = [];
      this.parcels_config = {
        value: "0.00",
        number: 1,
        interval: 1,
        date_first_parcel: "",
      };
      this.installment = 1;
      this.company = "";
      this.billing_type = 1;
    },
    dateToEua(date) {
      if (date == undefined) return "";
      return date.split("/").reverse().join("-");
    },
    generateParcels() {
      this.parcels = [];
      let [day, month_parcel, year_parcel] =
        this.parcels_config.date_first_parcel.split("/");
      const now = new Date();
      let total = this.getValueTotal();
      let interval = parseInt(this.parcels_config.interval);
      if (this.installment == 1) {
        let value_parcel = 0;
        let number = parseInt(this.parcels_config.number);
        if (total > 0) {
          value_parcel = (total / number).toFixed(2);
        }
        for (let index = 0; index < number; index++) {
          let next_date = new Date(
            year_parcel,
            parseInt(month_parcel) - 1,
            day,
            "00",
            "00",
            "01"
          );
          next_date.setDate(next_date.getDate() + interval * index);
          this.parcels.push({
            parcel: index + 1,
            issuance_date: this.formatDateParcel(now),
            due_date: this.formatDateParcel(next_date),
            value: value_parcel,
          });
        }
      } else {
        let value_parcel = parseFloat(this.parcels_config.value);
        let number = Math.ceil(total / value_parcel);

        for (let index = 0; index < number; index++) {
          let next_date = new Date(
            year_parcel,
            parseInt(month_parcel) - 1,
            day,
            "00",
            "00",
            "01"
          );
          next_date.setDate(next_date.getDate() + interval * index);
          if (index === number - 1) {
            this.parcels.push({
              parcel: index + 1,
              issuance_date: this.formatDateParcel(now),
              due_date: this.formatDateParcel(next_date),
              value: parseFloat((total - index * value_parcel).toFixed(2)),
            });
          } else {
            this.parcels.push({
              parcel: index + 1,
              issuance_date: this.formatDateParcel(now),
              due_date: this.formatDateParcel(next_date),
              value: value_parcel,
            });
          }
        }
      }
    },
    formatDateParcel(date) {
      return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1)
        .toString()
        .padStart(2, 0)}-${date.getUTCDate().toString().padStart(2, 0)}`;
    },
    validDisabledParcels() {
      let value = this.getValueTotal();
      if (value == 0) {
        return true;
      }
      return this.invoices.length == 0 && this.invoices_restitution.length > 0;
    },
    changeInstallment() {
      this.parcels_config = {
        value: "0.00",
        number: 1,
        interval: 1,
        date_first_parcel: "",
      };
    },
    handleClickCalendar() {
      this.dateDialog = this.dateToEua(this.parcels_config.date_first_parcel);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      this.parcels_config.date_first_parcel = this.dateToBr(this.dateDialog);
    },
    dateToBr(date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
    handleAddFinancial() {
      this.modalAddRelease = true;
    },
    closeAddRelease() {
      this.modalAddRelease = false;
    },
    confirmAddRelease() {
      console.log(this.form_release);
      let releaseTypeSelected = this.types_release.find(
        (item) => item.id === this.form_release.id
      );
      if (releaseTypeSelected) {
        this.releases.push({
          ...releaseTypeSelected,
          value: this.form_release.value,
          history: this.form_release.history.toUpperCase(),
        });
        console.log(this.releases);
      }
      this.modalAddRelease = false;
    },
    getTotalReleases(operation = null) {
      if (operation !== null) {
        return this.releases
          .filter((item) => item.operation === operation)
          .map((item) => parseFloat(item.value))
          .reduce((prev, curr) => prev + curr, 0)
          .toFixed(2);
      } else {
        return this.releases
          .map((item) =>
            item.operation === "desconto"
              ? parseFloat(item.value) * -1
              : parseFloat(item.value)
          )
          .reduce((prev, curr) => prev + curr, 0)
          .toFixed(2);
      }
    },
  },
};
</script>

<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.compact-form .fs-12 {
  transform: scale(0.75);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
